import * as React from 'react';
import './Loader.css';

export default (): JSX.Element => (
    <>
        <div className="loader-overlay" />
        <div className="loader">
            <div className="bounce1" />
            <div className="bounce2" />
            <div className="bounce3" />
            <div className="bounce4" />
        </div>
    </>
);



// WEBPACK FOOTER //
// ./src/view/common/Loader.tsx